import styled from 'styled-components'

const StyledTable = styled.table`
caption-side: top;
border: none;
border-collapse: collapse;
/* border-collapse: separate; */
/* border-spacing: 5px 10px; */

caption-side: bottom;
/* empty-cell: show | hide;  */
/* empty-cell is a property of table or the cells themselves */

/* vertical-align: baseline | sub | super | text-top | 
              text-bottom | middle | top | bottom | 
              <percentage> | <length> */

/* tbody {
  vertical-align: top;
}              */
td,
th {
  border: none;
}
/* td,
th {
  border: 1px solid;
} */

td {
  padding: 5px 10px;
  font-size: 0.9em;
}

tbody tr {
  :nth-of-type(odd) {
    background-color: #f6b519;
    color: #232C63;
  }
  :hover {
    background-color: #EF3D3B;
  }
}
thead > tr {
  background-color: #232c63;
  color:#f6b519;
}
caption {
  font-size: 0.8em;
  padding: 5px;
  font-weight: bold;
}
`;
export default ({ data }) => (
<TableMarkup titles={Object.keys(data[0])} data={data} />
);
const TableMarkup = ({ titles, data }) => (
<StyledTable>
  <colgroup>
    <col />
    <col />
    <col />
  </colgroup>
  <thead>
    <tr>
      {titles.map((title, index) => (
        <th key={index}>{title}</th>
      ))}
    </tr>
  </thead>
  <tbody>
    {data.map((item, index) => (
      <tr key={index}>
        {titles.map((title, index) => (
          <td key={index}>{item[title]}</td>
        ))}
      </tr>
    ))}
  </tbody>
  {/* <tfoot>
    <tr>
      {titles.map((title, index) => (
        <th key={index}>{title}</th>
      ))}
    </tr>
  </tfoot> */}
</StyledTable>
);
